export const DEFAULT_CAROUSEL_SPEED = 3000;
export const DEFAULT_ALIGNMENT_CLASS = 'align-self-center text-center';
export const DEFAULT_BG_COLOR = '#027ee5';
export const MAX_TEXT_LENGTH = 500;
